import { z } from "zod";

import { multiSelectResponseSchema } from "@components/PatientForms/common/schemaHelper";

/**
 * Medication Feedback validation schema
 * Validates the entire medicationFeedback category
 */

export const medicationFeedbackValidation = z.object({
  medicationFeedback: z.string().min(1, "Please enter your feedback"),
  medicationSymptoms: z
    .array(multiSelectResponseSchema)
    .min(1, "Please select at least one option"),
});

export default medicationFeedbackValidation;
